var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-item"},[_c('span',{staticClass:"caption"},[_vm._v(_vm._s(_vm.tag))]),_vm._v(" "),_c('button',{staticClass:"btn-delete",on:{"click":function($event){$event.preventDefault();return _vm.remove.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }